import { lazy } from 'react';

// project imports
import Loadable from 'ui-component/Loadable';
import MinimalLayout from 'layout/MinimalLayout';
import SamplePage from '../views/sample-page';

// login option 3 routing
const AuthLogin3 = Loadable(lazy(() => import('views/pages/authentication/authentication3/Login3')));
const AuthRegister3 = Loadable(lazy(() => import('views/pages/authentication/authentication3/Register3')));

const ForgotPass3 =Loadable(lazy(()=>import('views/pages/authentication/authentication3/ForgotPass3')))
const Mailverification =Loadable(lazy(()=>import('views/pages/authentication/auth-forms/Mailverification')))

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = {
    path: '/',
    element: <MinimalLayout />,
    children: [
        {
            path: '/login',
            element: <AuthLogin3 />
        },
        {
            path: '/register',
            element: <AuthRegister3 />
        },
        {
            path: '/forgotpass',
            element: <ForgotPass3 />
        },
        {
            path: '/sample',
            element: <SamplePage/>
        }
    ]
};

export default AuthenticationRoutes;